// ---------------------------------------------------------------------------
// Attendance module — presentation helpers
// Pure functions only (no React / no network) so they are trivial to unit test
// and reuse from any page inside the module.
// ---------------------------------------------------------------------------
import {ATTENDANCE_STATUS} from "../constants/AttendanceConstants";

// Single source of truth for how each status looks in the UI.
export const STATUS_META = {
    [ATTENDANCE_STATUS.PRESENT]: {label: "Present", color: "green", short: "P"},
    [ATTENDANCE_STATUS.ABSENT]: {label: "Absent", color: "red", short: "A"},
    [ATTENDANCE_STATUS.LATE]: {label: "Late", color: "orange", short: "L"},
    [ATTENDANCE_STATUS.LEAVE]: {label: "Leave", color: "purple", short: "Lv"},
};

export const STATUS_ORDER = [
    ATTENDANCE_STATUS.PRESENT,
    ATTENDANCE_STATUS.ABSENT,
    ATTENDANCE_STATUS.LATE,
    ATTENDANCE_STATUS.LEAVE,
];

export const getStatusMeta = (status) =>
    STATUS_META[status] || {label: status || "—", color: "gray", short: "?"};

// Today as an ISO yyyy-mm-dd string, in local time.
export const todayIso = () => {
    const d = new Date();
    const tz = d.getTimezoneOffset() * 60000;
    return new Date(d - tz).toISOString().slice(0, 10);
};

// Human friendly date, e.g. "Mon, 07 Jul 2026".
export const formatDate = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString(undefined, {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

// "14:32:05" -> "02:32 PM" (defensive against already-formatted values).
export const formatTime = (value) => {
    if (!value) return "—";
    const d = value instanceof Date ? value : new Date(`1970-01-01T${value}`);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleTimeString(undefined, {hour: "2-digit", minute: "2-digit"});
};

// Build attendance rate + per-status counts from a list of student rows.
export const summarize = (rows = []) => {
    const counts = STATUS_ORDER.reduce((acc, s) => ({...acc, [s]: 0}), {});
    rows.forEach((r) => {
        if (counts[r.status] !== undefined) counts[r.status] += 1;
    });
    const total = rows.length;
    const present = counts[ATTENDANCE_STATUS.PRESENT] + counts[ATTENDANCE_STATUS.LATE];
    const rate = total ? Math.round((present / total) * 100) : 0;
    return {total, counts, present, rate};
};
